import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import theme from '../../theme';
import { Box, Divider } from '@chakra-ui/react';
import { AdminListPageLayout } from '../../components/admin-list-page-layout/admin-list-page-layout';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { applyFilters, clearAllFilters } from '../../actions/audit-log';
import { DataGrid } from '../../components/data-grid/data-grid';
import { SearchBar } from '../../components/search-bar/search-bar';
import { PopUpFiltersV2 } from '../pop-up-filter/pop-up-filtersV2';
import { styles } from './audit-log.styles';
import { commonEnums as enums } from '@codametrix/ui-common';
import { RowsPerPage } from '../../components/rows-per-page/rows-per-page';
import { pageSizeGridOption } from '../dictionary/dictionary-list-constants';
const { FilterTypes } = enums;
const _isDictAction = (action)=>{
    return action.dictionaryEventType !== undefined;
};
export const colDefs = [
    {
        field: 'timestamp',
        headerName: 'Event Date',
        valueFormatter: (data)=>data.data.eventDate?.substring(0, 10),
        tooltipField: 'timestamp',
        width: 50,
        sortable: false
    },
    {
        field: 'username-email',
        headerName: 'Username',
        valueFormatter: (data)=>data.data?.username,
        tooltipField: 'username-email',
        tooltipValueGetter (params) {
            return params.data?.username;
        },
        sortable: false
    },
    {
        field: 'dictionaryEventType',
        headerName: 'Event Type',
        valueFormatter: (data)=>{
            return _isDictAction(data.data) ? data.data?.dictionaryEventType : data.data?.organizationEventType;
        }
    },
    {
        field: 'eventTarget',
        headerName: 'Event Target',
        valueFormatter: (data)=>{
            if (_isDictAction(data.data)) {
                return data.data.dictionaryName || data.data.deletedDictionaryName;
            }
            return data.data.organizationName || data.data.serviceLineName;
        }
    },
    {
        field: 'tenantID',
        headerName: 'Tenant',
        valueFormatter: (data)=>data.data?.tenantId,
        sortable: false
    },
    {
        field: 'dictEffectiveDate',
        headerName: 'Effective Date',
        valueFormatter: (data)=>data.data?.newDictionaryEffectiveDate,
        sortable: false
    },
    {
        field: 'jiraTicket',
        headerName: 'Jira Ticket',
        valueFormatter: (data)=>data.data?.jiraTicket,
        sortable: false
    }
];
const AuditLog = (props)=>{
    const dispatch = useDispatch();
    const classes = styles();
    const { sortablePageable, criteriaFilter, filterLoadStates, getList, activeOrgId, auditLogs } = props;
    const searchForms = useMemo(()=>criteriaFilter?.searchForms.map((filterForm)=>{
            return {
                label: filterForm.label,
                value: filterForm.key
            };
        }), [
        criteriaFilter
    ]);
    const [selectedOption, setSelectedOption] = useState(searchForms?.[0]?.label);
    const [searchText, setSearchText] = useState('');
    const [pageSize, setPageSize] = useState(25);
    const [filterableOptions, setFilterableOptions] = useState(sortablePageable?.filterableOptions);
    useEffect(()=>{
        getList({
            ...sortablePageable,
            filterableOptions,
            pageableDefinition: {
                ...sortablePageable.pageableDefinition,
                pageable: {
                    ...sortablePageable.pageableDefinition.pageable,
                    pageSize: sortablePageable.pageableDefinition.totalElements
                }
            }
        });
        dispatch(applyFilters(filterableOptions));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filterableOptions
    ]);
    const handleSearchOptionChange = (event)=>{
        setSelectedOption(event?.target?.textContent);
    };
    const handleSearchInputChange = (event)=>{
        setSearchText(event?.target?.value);
    };
    const handleSearchKeyPress = (event)=>{
        if (event?.keyCode === 13) {
            let newFilterList = [];
            const selectedOptionKey = searchForms.find((searchForm)=>searchForm.label === selectedOption)?.value ?? '';
            newFilterList = criteriaFilter.filters.filter((filter)=>{
                return filter.type === FilterTypes.IN;
            });
            const SearchFormMatch = criteriaFilter.searchForms.find((filter)=>{
                return filter.key === selectedOptionKey;
            });
            if (SearchFormMatch) {
                const newFilter = {
                    key: selectedOptionKey,
                    terms: [
                        searchText.trim()
                    ],
                    type: SearchFormMatch.type
                };
                newFilterList.push(newFilter);
            }
            setFilterableOptions({
                filters: newFilterList,
                dateFilter: filterableOptions.dateFilter
            });
        }
    };
    const clearFilters = ()=>{
        setFilterableOptions({});
        setSearchText('');
        dispatch(clearAllFilters());
    };
    const onPageSizeChange = (pageSize)=>{
        setPageSize(pageSize);
    };
    return /*#__PURE__*/ _jsxs(AdminListPageLayout, {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                flexShrink: 0,
                children: /*#__PURE__*/ _jsx(SearchBar, {
                    selectOptions: searchForms,
                    selectedOption: selectedOption,
                    onSelectOptionChange: handleSearchOptionChange,
                    onSearchInputChange: handleSearchInputChange,
                    onSearchKeyPress: handleSearchKeyPress
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                flexShrink: 0,
                paddingTop: theme.space[12],
                children: /*#__PURE__*/ _jsx(Divider, {
                    sx: classes.divider
                })
            }),
            /*#__PURE__*/ _jsxs(Box, {
                flexShrink: 0,
                paddingTop: theme.space[12],
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ _jsx(PopUpFiltersV2, {
                        criteriaFilter: criteriaFilter,
                        loadStates: filterLoadStates,
                        sortablePageable: sortablePageable,
                        list: ()=>getList({
                                ...sortablePageable,
                                filterableOptions
                            }),
                        getDictionary: ()=>{},
                        getStatuses: ()=>{},
                        getTenants: ()=>{},
                        clearFilters: clearFilters,
                        activeOrgId: activeOrgId,
                        setFilterableOptions: setFilterableOptions
                    }),
                    /*#__PURE__*/ _jsx(RowsPerPage, {
                        pageSize: pageSize,
                        handlePageSize: onPageSizeChange
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                paddingTop: theme.space[12],
                flex: "1 1 0",
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                children: /*#__PURE__*/ _jsx(DataGrid, {
                    columnDefs: colDefs,
                    rowData: auditLogs,
                    paginationPageSize: pageSize,
                    gridOptions: pageSizeGridOption
                })
            })
        ]
    });
};
export { AuditLog };
